import {useState} from "react";
import FormField from "../form/Field"

import UseGetterNodeError from "./hooks/UseGetterNodeError";
import UseSetterNodeError from "./hooks/UseSetterNodeError";
import UseGetterNodeValue from "./hooks/UseGetterNodeValue";
import UseSetterNodeValue from "./hooks/UseSetterNodeValue";

const Field = (props) => {

    const changeTypes = ['select', 'radio', 'checkbox', 'datetime-local', 'time']
    const [error, setError] = useState(UseGetterNodeError(props.node, props.tab, props.name))
    const [value, setValue] = useState(UseGetterNodeValue(props.node, props.tab, props.name, props.defaultValue))


    const handleBlur = (interaction) => {
        if (typeof props.onBlur == "function") {
            props.onBlur(interaction)
        }

        if (!changeTypes.includes(props.type)) {
            setError(null)
            UseSetterNodeError(props.node, props.tab, props.name, null)
        }

        const newValue = isEvent(interaction) ? interaction.target.value : interaction
        UseSetterNodeValue(props.node, props.tab, props.name, newValue)
        setValue(newValue)
    }


    /*
     * @param interaction
     */
    const handleChange = (interaction) => {
        if (changeTypes.includes(props.type)) {

            if (typeof props.onChange == "function") {
                props.onChange(interaction)
            }

            if (changeTypes.includes(props.type)) {
                setError(null)
                UseSetterNodeError(props.node, props.tab, props.name, null)
            }

            const newValue = isEvent(interaction) ? interaction.target.value : interaction
            UseSetterNodeValue(props.node, props.tab, props.name, newValue)
            setValue(newValue)
        }
    }


    const handleRender = () => {
        if (props && typeof props.onRender == "function") {
            props.onRender({value: value})
        }
    }


    /**
     *
     * @param interaction
     * @returns {boolean}
     */
    const isEvent = (interaction) => {
        return interaction && typeof interaction == "object" &&
            interaction.nativeEvent instanceof Event
    }


    const FieldOptions = {
        min         : props.min,
        name        : props.name,
        type        : props.type,
        label       : props.label,
        inline      : props.inline,
        wrapper     : props.wrapper,
        options     : props.options,
        tools       : props.tools,
        disabled    : props.disabled,
        required    : props.required,
        className   : props.className,
        placeholder : props.placeholder,
        readOnly    : props.readOnly,
        canCopy     : props.canCopy,
        isMulti     : props.isMulti,
        isClearable : props.isClearable,
        isSearchable: props.isSearchable,
        prepend     : props.prepend,
        info        : props.info,
        onBlur      : handleBlur,
        onChange    : handleChange,
        onRender    : handleRender,
        error       : error,
        value       : value,
        addon       : props?.addon,
    }


    return (
        <div>
            <FormField {...FieldOptions}/>
            {!FieldOptions.label && error && <span className="error">{error}</span>}
        </div>
    )
}

export default Field